import React, { useState } from 'react';
import './MarkPaidActions.css';

const PAYMENT_METHODS = [
    { value: 'bank_transfer', label: 'Bank transfer' },
    { value: 'eftpos', label: 'EFTPOS' },
    { value: 'cash', label: 'Cash' },
    { value: 'other', label: 'Other' },
];

const MarkPaidActions = ({ onMarkPaid, onCancel, isSubmitting = false }) => {
    const [method, setMethod] = useState('bank_transfer');
    const [notes, setNotes] = useState('');

    const isOther = method === 'other';
    const canSubmit = !isSubmitting && (!isOther || notes.trim().length > 0);

    const handleMethodChange = e => {
        setMethod(e.target.value);
        setNotes('');
    };

    const handleMark = () => {
        if (canSubmit) {
            onMarkPaid(method, isOther ? notes.trim() : null);
        }
    };

    return (
        <div className="mark-paid-actions">
            <div className="mark-paid-actions-row">
                <select
                    className="mark-paid-actions-select"
                    value={method}
                    onChange={handleMethodChange}
                    disabled={isSubmitting}>
                    {PAYMENT_METHODS.map(m => (
                        <option key={m.value} value={m.value}>{m.label}</option>
                    ))}
                </select>
                <button
                    className="btn-turquoise btn-small"
                    onClick={handleMark}
                    disabled={!canSubmit}>
                    Mark paid
                </button>
                {onCancel && (
                    <button
                        className="btn-danger btn-small"
                        onClick={onCancel}
                        disabled={isSubmitting}>
                        Cancel record
                    </button>
                )}
            </div>
            {isOther && (
                <input
                    type="text"
                    className="mark-paid-actions-notes"
                    placeholder="Describe the payment method (required)"
                    value={notes}
                    onChange={e => setNotes(e.target.value)}
                    disabled={isSubmitting}
                />
            )}
        </div>
    );
};

export default MarkPaidActions;
